import React from 'react'
import styled from 'styled-components'
// import posed from 'react-pose'
import Img from 'gatsby-image'
import H3 from '../components/h3'

const StyledOverlapCarousel = styled.div``

const StyledImg = styled(Img)`
  border-radius: 10px;
`

const HalfImage = styled.div`
  width: 70%;
  position: absolute;
  margin-right: 5rem;
  top: 0px;
  right: 0px;
  z-index: 4;
  box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  /* transition: all 0.5s ease-out; */

  &:nth-child(2) {
    top: 9%;
    right: 5%;
    z-index: 3;
    opacity: 1;
    filter: contrast(20%) brightness(150%);
    transform: scale(0.95);
  }
  &:nth-child(3) {
    top: 18%;
    right: 10%;
    z-index: 2;
    opacity: 1;
    filter: contrast(20%) brightness(150%);
    transform: scale(0.9);
  }
  &:nth-child(4) {
    top: 27%;
    right: 15%;
    z-index: 1;
    opacity: 1;
    filter: contrast(20%) brightness(150%);
    transform: scale(0.85);
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: 1rem 0;
  }
  &:hover {
    z-index: 6;
    opacity: 1;
    filter: contrast(100%) brightness(100%);
    transform: scale(1);
  }
`

const SideText = styled.div`
  width: 30%;
  padding: 5rem 2rem 0 0rem;
  max-width: 300px;
  @media (max-width: 768px) {
    width: 90%;
    margin: 1rem 0;
    padding: 1rem 1rem;
  }
`

const CaseP = styled.p`
  color: #828282;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  line-height: 1.45;
`

const TwoColumns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: -7rem;
  margin-top: 7rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

const ImageStack = styled.div`
  width: 70%;
  height: calc(50vw);
  position: relative;
  margin-right: 2rem;
  @media (max-width: 768px) {
    height: calc(43vw + 120px);
    margin-right: 0;
  }
`

class OverlapCarousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hoverIndex: 1,
    }
  }

  handleHover(index) {
    this.setState({ hoverIndex: index })
  }

  render() {
    return (
      <StyledOverlapCarousel>
        <TwoColumns>
          <ImageStack>
            <HalfImage onMouseEnter>
              <StyledImg fluid={this.props.data.hyper2.childImageSharp.fluid} />
            </HalfImage>
            <HalfImage>
              <StyledImg
                fluid={this.props.data.hyper1_2.childImageSharp.fluid}
              />
            </HalfImage>
            <HalfImage>
              <StyledImg fluid={this.props.data.talk2.childImageSharp.fluid} />
            </HalfImage>
            <HalfImage>
              <StyledImg
                fluid={this.props.data.hyper1_1.childImageSharp.fluid}
              />
            </HalfImage>
          </ImageStack>
          <SideText>
            <H3>Speaking</H3>
            <CaseP>
              Shown here is stages of redesign of the BandPage landing page,
              featuring a new mobile onboarding with more lucid communication
              and new value propositions.
            </CaseP>
            <CaseP>
              Such redesigns were instigated as the startup's audience shifted
              within the music management industry, ranging from fan-serving
              products, to tools for indie musicians and to record labels and
              managers.
            </CaseP>
          </SideText>
        </TwoColumns>
      </StyledOverlapCarousel>
    )
  }
}

export default OverlapCarousel
